import { useQuery, UseQueryResult } from 'react-query'

import {
  buildFiltersV2Payload,
  type AlertFilterState,
} from 'features/alerts/features/create-alert/alert-filter-state'
import type { AlertService } from 'features/alerts/service'

type AlertChartQueryParams = {
  projectId: string
  alert_scope: string
  alert_type: string
  compare_value: number
  trigger_type: string
  time_interval: string
  filterState: AlertFilterState
  enabled: boolean
}

export function useAlertChartQuery(
  alertService: AlertService,
  params: AlertChartQueryParams,
): UseQueryResult<unknown> {
  return useQuery(
    [
      'alert-chart',
      params.projectId,
      params.alert_scope,
      params.alert_type,
      params.compare_value,
      params.trigger_type,
      params.time_interval,
      // Serialize by value so a new object identity with the same contents
      // doesn't produce a cache miss and fire a redundant 5s backend call.
      JSON.stringify(params.filterState),
    ],
    () => {
      return alertService.getAlertChart(params.projectId, {
        title: '',
        alert_scope: params.alert_scope,
        alert_type: params.alert_type,
        compare_value: params.compare_value,
        trigger_type: params.trigger_type,
        time_interval: params.time_interval,
        reviews_filter: 0,
        shared_users: [],
        filters_v2: buildFiltersV2Payload(params.filterState),
        status: 'Active',
        is_grouped: true,
      })
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: params.enabled,
    },
  )
}
